import { useCallback } from "react";
import { createTrackingUtils } from "../index";
import useProfiler from "../../../hooks/useProfiler";
import { useCheckoutAncillaryOffersController } from "../../../ancillaries/components/CheckoutAncillaryOffers/useCheckoutAncillaryOffers.controller";

const util = createTrackingUtils({
  name: "flights_web_mdot_extras_content_hierarchy",
  defaultStage: 1,
  stages: {
    main: 1,
    direct: 2,
    meta: 3,
    family: 4,
    weekend: 5,
    longhaul: 6,
    flexible: 7,
    insurance: 8,
    fasttrack: 9
  },
  goals: {
    insurance: 1,
    flexi: 2,
    fast: 3,
    meals: 4
  },
  goalsWithValue: []
});

export function useFlightsWebMdotExtrasContentHierarchy() {
  const { isMobile, isDirect, isFamily, isLongHaul, isWeekendStay } = useProfiler();
  const { canRenderFlexibleTicket, canRenderTravelInsurance, canRenderFastTrackExtras } =
    useCheckoutAncillaryOffersController({
      setMpState: undefined
    });

  const trackStages = useCallback(() => {
    if (!isMobile()) return;
    util.stages.main();
    if (isDirect()) util.stages.direct();
    if (!isDirect()) util.stages.meta();
    if (isFamily()) util.stages.family();
    if (isWeekendStay()) util.stages.weekend();
    if (isLongHaul()) util.stages.longhaul();
    if (canRenderFlexibleTicket) util.stages.flexible();
    if (canRenderTravelInsurance) util.stages.insurance();
    if (canRenderFastTrackExtras) util.stages.fasttrack();
  }, [
    isMobile,
    isDirect,
    isFamily,
    isLongHaul,
    isWeekendStay,
    canRenderFlexibleTicket,
    canRenderFastTrackExtras,
    canRenderTravelInsurance
  ]);

  const isVariant = useCallback(() => {
    if (!isMobile()) return false;
    trackStages();
    return !!util.trackWithDefaultStage();
  }, [isMobile, trackStages]);

  return { isVariant, goals: util.goals };
}
